import React, {useEffect, useRef, useState} from 'react';
import Slider from "react-slick";
import {FaArrowLeft, FaArrowRight} from "react-icons/fa";
import {useSelector} from "react-redux";
import Modal from "./Modal";
import {fetchProductInMainPage} from "../actions/product";
import MainProductCard from "./MainProductCard";

const MainProduct = () => {
    const isModalOpen = useSelector(state => state.modal.show);

    const [visible1, setVisible1] = useState(true);
    const [visible2, setVisible2] = useState(false);
    const [visible3, setVisible3] = useState(false);
    const [visible4, setVisible4] = useState(false);
    const [productLocal1, setProductLocal1] = useState([]);
    const [productLocal2, setProductLocal2] = useState([]);
    const [productLocal3, setProductLocal3] = useState([]);
    const [productLocal4, setProductLocal4] = useState([]);
    const [chunkedProducts1, setChunkedProducts1] = useState([]);
    const [chunkedProducts2, setChunkedProducts2] = useState([]);
    const [chunkedProducts3, setChunkedProducts3] = useState([]);
    const [chunkedProducts4, setChunkedProducts4] = useState([]);
    const [sizeWindow, setSizeWindow] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const [key1, setKey1] = useState(0);
    const [key2, setKey2] = useState(0);
    const [key3, setKey3] = useState(0);
    const [key4, setKey4] = useState(0);

    // Кастомная кнопка "назад"
    const PrevArrow = ({onClick}) => (
        <button className="slick-arrow prev" onClick={onClick}>
            <FaArrowLeft color="#79a206"/>
        </button>
    );

    // Кастомная кнопка "вперёд"
    const NextArrow = ({onClick}) => (
        <button className="slick-arrow next" onClick={onClick}>
            <FaArrowRight color="#79a206"/>
        </button>
    );

    const [settings, setSettings] = useState({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: sizeWindow < 768 ? 1 : 4,
        slidesToScroll: sizeWindow < 768 ? 1 : 4,
        autoplay: false,
        prevArrow: <PrevArrow/>,
        nextArrow: <NextArrow/>
    })

    const setVisible = (windowNumber) => {
        if (windowNumber === 1) {
            setVisible1(true);
            setVisible2(false);
            setVisible3(false);
            setVisible4(false);
        } else if (windowNumber === 2) {
            setVisible1(false);
            setVisible2(true);
            setVisible3(false);
            setVisible4(false);
        } else if (windowNumber === 3){
            setVisible1(false);
            setVisible2(false);
            setVisible3(true);
            setVisible4(false);
        } else {
            setVisible1(false);
            setVisible2(false);
            setVisible3(false);
            setVisible4(true);
        }
    }

    useEffect(() => {
        isModalOpen ? document.body.classList.add("modal-open") : document.body.classList.remove("modal-open");
    }, [isModalOpen]);

    useEffect(() => {
        (async () => {
            const data = await fetchProductInMainPage();
            setProductLocal1(data[0]);
            setProductLocal2(data[1]);
            setProductLocal3(data[2]);
            setProductLocal4(data[3]);
        })();

        const handleResize = () => {
            setSizeWindow({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener("resize", handleResize);

        setSettings({
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: sizeWindow.width < 768 ? 1 : 4,
            slidesToScroll: sizeWindow.width < 768 ? 1 : 4,
            autoplay: false,
            prevArrow: <PrevArrow/>,
            nextArrow: <NextArrow/>
        })
    }, []);

    useEffect(() => {
        setSettings({
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: sizeWindow.width < 768 ? 1 : 4,
            slidesToScroll: sizeWindow.width < 768 ? 1 : 4,
            autoplay: false,
            prevArrow: <PrevArrow/>,
            nextArrow: <NextArrow/>
        })
    }, [sizeWindow]);

    useEffect(() => {
        // Группируем данные в пары, как только данные обновлены
        const chunked1 = [];
        const chunked2 = [];
        const chunked3 = [];
        const chunked4 = [];
        for (let i = 0; i < productLocal1.length; i += 2) {
            chunked1.push(productLocal1.slice(i, i + 2));
        }
        setChunkedProducts1(chunked1);

        for (let i = 0; i < productLocal2.length; i += 2) {
            chunked2.push(productLocal2.slice(i, i + 2));
        }
        setChunkedProducts2(chunked2);

        for (let i = 0; i < productLocal3.length; i += 2) {
            chunked3.push(productLocal3.slice(i, i + 2));
        }
        setChunkedProducts3(chunked3);

        for (let i = 0; i < productLocal4.length; i += 2) {
            chunked4.push(productLocal4.slice(i, i + 2));
        }
        setChunkedProducts4(chunked4);

    }, [productLocal1, productLocal2, productLocal3, productLocal4]);

    useEffect(() => {
        setKey1(prevKey => prevKey + 1);
        setKey2(prevKey => prevKey + 1);
        setKey3(prevKey => prevKey + 1);
        setKey4(prevKey => prevKey + 1);
    }, [settings]);
    return (
        <div>
            <div className="product_area mb-95">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="product_header">
                                <div className="section_title">
                                    <h2>Продукция</h2>
                                </div>
                                <div className="product_tab_btn">
                                    <ul className="nav" role="tablist">
                                        <li>
                                            <a className={visible1 && 'active'} data-toggle="tab" href="#"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   setVisible(1);
                                               }} role="tab"
                                               aria-controls="plant1"
                                               aria-selected="true">
                                                Брусок строганный
                                            </a>
                                        </li>
                                        <li>
                                            <a className={visible2 && 'active'} data-toggle="tab" href="#"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   setVisible(2);
                                               }} role="tab" aria-controls="plant2"
                                               aria-selected="false">
                                                Доска обрезная 1 сорт
                                            </a>
                                        </li>
                                        <li>
                                            <a className={visible3 && 'active'} data-toggle="tab" href="#"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   setVisible(3);
                                               }} role="tab" aria-controls="plant3"
                                               aria-selected="false">
                                                Блок-Хаус
                                            </a>
                                        </li>
                                        <li>
                                            <a className={visible4 && 'active'} data-toggle="tab" href="#"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   setVisible(4);
                                               }} role="tab" aria-controls="plant3"
                                               aria-selected="false">
                                                Штиль
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tab-content">
                        <div className={`tab-pane fade ${visible1 && 'show active'}`} id="plant1" role="tabpanel">
                            <div className="row">
                                <Slider key={key1} {...settings}>
                                    {chunkedProducts1.map((pair, index) => (
                                        <MainProductCard pair={pair} key={index}/>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                        <div className={`tab-pane fade ${visible2 && 'show active'}`} id="plant2" role="tabpanel">
                            <div className="row">
                                <Slider key={key2} {...settings}>
                                    {chunkedProducts2.map((pair, index) => (
                                        <MainProductCard pair={pair} key={index}/>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                        <div className={`tab-pane fade ${visible3 && 'show active'}`} id="plant3" role="tabpanel">
                            <div className="row">
                                <Slider key={key3} {...settings}>
                                    {chunkedProducts3.map((pair, index) => (
                                        <MainProductCard pair={pair} key={index}/>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                        <div className={`tab-pane fade ${visible4 && 'show active'}`} id="plant4" role="tabpanel">
                            <div className="row">
                                <Slider key={key4} {...settings}>
                                    {chunkedProducts4.map((pair, index) => (
                                        <MainProductCard pair={pair} key={index}/>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*Модальное окно*/}
            <Modal/>
        </div>
    );
};

export default MainProduct;